import { MutableRefObject, useEffect } from 'react'
import { Form, useForm } from 'react-final-form'

import { TextareaType } from 'common/components/dynamicFields/interfaces'
import { isComponentElement } from 'features/unifiedFlow/api/interfaces'
import useGetSplitCalculatorConfigurationQuery from 'features/unifiedFlow/api/queries/useGetSplitCalculatorConfigurationQuery'
import ControlSubjectLine from 'features/unifiedFlow/components/templateSelection/setupExperiment/ControlSubjectLine'
import { useSelectedElement } from 'features/unifiedFlow/contentPage/hooks'

type Props = {
  isDisabled: boolean
  selectedControlLine?: string
  controlLineRef?: MutableRefObject<string>
  onValueChange?: (value: string) => void
}

const FormValueSyncer = ({ value }: { value: string }) => {
  const form = useForm()
  useEffect(() => {
    form.change('controlSubjectLine', value)
  }, [form, value])
  return null
}

const ControlBoxSection = ({
  isDisabled,
  selectedControlLine,
  controlLineRef,
  onValueChange,
}: Props) => {
  const { data: selectedElement } = useSelectedElement()

  const optimizationSettings =
    selectedElement && isComponentElement(selectedElement)
      ? selectedElement?.optimization_settings?.configuration
      : undefined

  const selectedProjectId = optimizationSettings?.project_id

  const { data: projectSplitCalculatorConfiguration } =
    useGetSplitCalculatorConfigurationQuery({ projectId: selectedProjectId })

  const controlSubjectLineConfig =
    projectSplitCalculatorConfiguration?.experimentMainFields?.find(
      (field) => field.name === 'own_subject_line'
    )

  const integrationType = projectSplitCalculatorConfiguration?.integrationType

  if (!controlSubjectLineConfig || !optimizationSettings) {
    return null
  }

  return (
    <Form
      initialValues={{
        controlSubjectLine: optimizationSettings.own_subject_line ?? '',
      }}
      onSubmit={() => {}}
      render={({ values }) => {
        const currentValue = values.controlSubjectLine ?? ''
        if (controlLineRef) {
          controlLineRef.current = currentValue
        }
        onValueChange?.(currentValue)
        return (
          <form>
            {selectedControlLine !== undefined && (
              <FormValueSyncer value={selectedControlLine} />
            )}
            <ControlSubjectLine
              name="controlSubjectLine"
              config={controlSubjectLineConfig as TextareaType}
              integrationType={integrationType}
              isDisabled={isDisabled}
            />
          </form>
        )
      }}
    />
  )
}

export default ControlBoxSection
